import { FC } from 'react'
import classNames from 'classnames'

interface Props {
  className?: string
  from: string
  to: string
  size: number | string
}

export const RadialGradient: FC<Props> = ({ className, from, to, size }) => {
  return (
    <div
      className={classNames('rounded-full', className)}
      style={{
        background: `radial-gradient(${from}, ${to})`,
        aspectRatio: 1,
        width: size,
      }}
    />
  )
}
